import { http } from "../../../config/HttpMethod";
import { ESP_ENDPOINTS } from "../endpoints";


export const getCableLength = async (data: object) => {
    const response = await http.post(`${ESP_ENDPOINTS?.GET_CABLE_LENGTH}`, data);
    return response.data;
};

export const getCableVoltData = async (data: object) => {
    const response = await http.post(`${ESP_ENDPOINTS?.GET_CABLE_VOLT_DATA}`, data);
    return response.data;
};

export const getWellCableList = async (payload: any) => {
    try {
        const { data, catalogFilter } = payload;

        if (!data || catalogFilter === undefined || catalogFilter === null) {
            throw new Error('Invalid parameters: MotorSers and catalogFilter are required');
        }

        const params = { MotrSers: data, catalogFilter: catalogFilter };
        const response = await http.get(`${ESP_ENDPOINTS?.GET_WELL_CABLE_LIST}`, { params });
        return response.data;
    } catch (error) {
        return {
            cableSizeList: [],
            lockPlateList: {}
        };
    }
};

export const getMotorLeadList = async (payload: any) => {
    const { data, catalogFilter } = payload;
    const params = { MotrSers: data, catalogFilter: catalogFilter };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_MOTOR_LEAD_LIST}`, { params });
    return response.data;
};

export const getWellEquipments = async (payload: any) => {
    const { awgId, pumpSetting, catalogFilter } = payload;
    const params = { awg_Id: awgId, length: pumpSetting, catalogFilter: catalogFilter };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_CABLES}`, { params });
    return response.data;
};

export const getMotorEquipments = async (payload: any) => {
    const { series, catalogFilter } = payload;
    const params = { series: series, catalogFilter: catalogFilter };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_MLE}`, { params });
    return response.data;
};

export const getClearanceData = async (payload: object) => {
    const response = await http.post(`${ESP_ENDPOINTS?.GET_CLEARANCE_DATA}`, payload);
    return response.data;
};

export const getLoadCharts = async (payload: any) => {
    if (typeof payload[4] === 'string' && payload[4].includes(',')) {
        payload[4] = payload[4].split(',')[0];
    }
    const response = await http.post(`${ESP_ENDPOINTS?.GET_CLEARANCE_CHART}`, payload);
    return response.data;
};
